export default __webpack_public_path__ + "static/media/dashboard-stat-icon.0b53cac2.svg";